'use client';

import { LinkStyled, ImageBj } from '@components/common';
import { useTranslation } from 'next-i18next';
import { useExtendedRouter } from '@hooks/next-routing-wrappers';
import bestieImage from '@images/agent/bestie-white-bg.png';

const EXCLUDED_PATHS = ['/bestie', '/audio-interview', '/messages'];

/**
 * @description Floating Action Button for Chat functionality.
 * Fixed positioned button that appears on all pages to provide quick access to chat.
 */
export const ChatFAB = () => {
  const { t } = useTranslation('common');
  const { pathname } = useExtendedRouter();

  // Hide FAB when user is on an excluded path
  if (pathname && EXCLUDED_PATHS.includes(pathname)) {
    return null;
  }

  return (
    <LinkStyled
      href="/bestie"
      className="fixed bottom-32 right-6 z-30 flex size-14 items-center justify-center rounded-full bg-secondary !p-0 shadow-lg transition-all duration-300 hover:bg-secondary-dark hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-secondary focus:ring-offset-2 md:size-16 lg:bottom-10"
      aria-label={t('header.label.bia')}
    >
      <ImageBj
        src={bestieImage}
        alt="Bestie"
        className="size-full"
      />
    </LinkStyled>
  );
};
